/* @flow */

import * as React from 'react';
import { inject, observer } from 'mobx-react';
import { action } from 'mobx';

//----------------------------------------------------------------------//
// MATERIAL UI                                                          //
//----------------------------------------------------------------------//

import IconButton from '@material-ui/core/IconButton';

//----------------------------------------------------------------------//
//----------------------------------------------------------------------//

import type TypeActionDrawerStore from 'stores/ActionDrawerStore.js';

import styles from './ActionDrawerHeader.module.scss';

type TypeProps = {
  title: string,
  disableCloseButton: boolean,
  actionDrawerStore: TypeActionDrawerStore,
};

@inject('actionDrawerStore')
@observer
export default class ActionDrawerHeader extends React.Component<*> {
  static defaultProps = {
    title: '',
    disableCloseButton: false,
  };

  @action handleActionDrawerClose = () => {
    const actionDrawerStore: TypeActionDrawerStore = this.props.actionDrawerStore;
    actionDrawerStore.closeActionDrawer();
  };

  render(): React.Node {
    const { title, disableCloseButton }: TypeProps = this.props;

    return (
      <div className={styles['form-drawer-header']}>
        <h2>{title}</h2>
        {!disableCloseButton && (
          <IconButton
            className={styles['form-drawer-close']}
            onClick={this.handleActionDrawerClose}
          >
            <svg className={styles['icon-close']}>
              <use xlinkHref="#icon-close" />
            </svg>
          </IconButton>
        )}
      </div>
    );
  }
}
